<header>
  <nav class="navbar fixed-top navbar-expand-lg navbar-dark header-sgi">
    <a class="navbar-brand" href="#">
      <img class="logo-sgi" src="assets/img/logo/sgi-mini.png" />
    </a>
  </nav>
</header>